import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { getAppVersion } from '../helper/helper';

const BottomBranding = () => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const versionData = await getAppVersion();
        if (versionData) {
          setVersion(versionData);
        }
      } catch (error) {
        console.error('Error fetching version:', error);
      }
    };

    fetchVersion();
  }, []);

  return (
    <Box>
      <Typography variant="subtitle1" textAlign="center" color="textSecondary" p={10}>
        CROBO version {version || "1.0.2"}
      </Typography>
    </Box>
  );
}

export default BottomBranding;